import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import MembershipCategoryServices from '../../services/MembershipCategoryServices';

function UpdateMembershipCategory({ membership, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    name: '',
    // price: '',
    // durationDays: '',
    description: '',
    // maxOrdersPerDay: '',
    // maxDiscountPerOrder: '',
    // discountPercent: ''
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  useEffect(() => {
    if (membership) {
      setFormValues({
        name: membership?.name || '',
        // price: membership?.price || '',
        // durationDays: membership?.durationDays || '',
        description: membership?.description || '',
        // maxOrdersPerDay: membership?.benefits?.maxOrdersPerDay || '',
        // maxDiscountPerOrder: membership?.benefits?.maxDiscountPerOrder || '',
        // discountPercent: membership?.benefits?.discountPercent || '',
      });
    }
  }, [membership]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const membershipId = membership?._id;

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleNumberPaste = (e) => {
    const pasteData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  };

 const handleSubmit = async (event) => {
  event.preventDefault();
  if (!membershipId) {
    return;
  }

  try {
    const data = {
      name: formValues.name,
      // price: formValues.price,
      // durationDays: formValues.durationDays,
      description: formValues.description,
      // benefits: {
      //   maxOrdersPerDay: formValues.maxOrdersPerDay,
      //   maxDiscountPerOrder: formValues.maxDiscountPerOrder,
      //   discountPercent: formValues.discountPercent
      // }
    };

    await MembershipCategoryServices.updateMembershipsCategory(membership._id, data);
    alert('Membership updated successfully');
    onSuccess();
    closeModal();
  } catch (error) {
    console.error('Failed to update Membership', error);
    alert('Failed to update Membership');
  }
};

  return (
    <div className="modal fade edit-box show d-block" id="editModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Membership Category</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <div className="modal-body">
            <div className="container-box px-5">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="input-field">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formValues.name}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>

                    {/* <div className="input-field">
                      <label>Price</label>
                      <input
                        type="number"
                        name="price"
                        value={formValues.price}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                   
                      />
                    </div>

                    <div className="input-field">
                      <label>Duration Days</label>
                      <input
                        type="number"
                        name="durationDays"
                        value={formValues.durationDays}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                      />
                    </div> */}

                    <div className="input-field">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={formValues.description}
                        onChange={handleInputChange}
                        className="form-control"
                        style={{ height: "100px" }}
                      />
                    </div>

                    {/* <div className="input-field">
                      <label>Max Orders Per Day</label>
                      <input
                        type="number"
                        name="maxOrdersPerDay"
                        value={formValues.maxOrdersPerDay}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"    
                      />
                    </div>
                    <div className="input-field">
                      <label>Max Discount Per Order</label>
                      <input
                        type="number"
                        name="maxDiscountPerOrder"
                        value={formValues.maxDiscountPerOrder}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"             
                      />
                    </div>
                    <div className="input-field">
                      <label>Discount Percent</label>
                      <input
                        type="number"
                        name="discountPercent"
                        value={formValues.discountPercent}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        onPaste={handleNumberPaste}
                        className="form-control"
                      />
                    </div>  */}

                  </div>

                  <button className="submit-green-btn">Submit</button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UpdateMembershipCategory;